import { LoopLogoBadge } from './LoopLogoBadge';

type NativeItemIndicatorProps = {
  externalKey?: string | null;
  size?: number;
};

export const NativeItemIndicator = ({ externalKey, size }: NativeItemIndicatorProps) => {
  const isExternalItem = !!externalKey;

  if (isExternalItem) {
    return null;
  }

  return (
    <span className="flex-none text-icon-default" data-testid="native-item-indicator">
      <LoopLogoBadge width={size} height={size} />
    </span>
  );
};
